import { DEFAULT_WEBSITES_DELIMITER } from "app/services/sitesService/consts";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const isCompareMode = (): boolean => {
    const params = proNavigator.getParams();
    const { key } = params;
    const isCompare = key.split(DEFAULT_WEBSITES_DELIMITER).length > 1;
    return isCompare;
};
